module.exports = __webpack_public_path__ + "img/0Q3B1666_L_BlackMatted_MockedUp.51d3296f.jpg";